import type { FormError } from 'asap-team/asap-tools';

export const apiError: FormError = {
  name: 'api_error',
  text: '',
  rules: ['touched', 'dirty'],
};
